export enum OrderByDirection {
    ASC = 'asc',
    DESC = 'desc',
}